import { BaseAction } from './BaseAction';
import { Organization } from '../../shared/models/organization';

export enum OrgHierarchyActions {
  LoadOrg = '[Org Hierarchy] Load Org',
  LoadOrgSuccess = '[Org Hierarchy] Load Org Success',
  LoadOrgFailed = '[Org Hierarchy] Load Org Failed',
  LoadOrgSubscriptionStatus = '[Org Hierarchy] Load OrgLoad Subscription Status',
  LoadOrgSubscriptionStatusSuccess = '[Org Hierarchy] Load Org Subscription Status Success',
  LoadOrgSubscriptionStatusFailed = '[Org Hierarchy] Load Org Subscription Status Failed',
  LoadOrgChildren = '[Org Hierarchy] Load Org Children',
  LoadOrgChildrenSuccess = '[Org Hierarchy] Load Org Children Success',
  LoadOrgChildrenFailed = '[Org Hierarchy] Load Org Children Failed',
  SelectOrg = '[Org Hierarchy] SelectOrg',
  SelectActiveNode = '[Org Hierarchy] SelectActiveNode',
  LoadSelectedOrg = '[Org Hierarchy] Load Selected Org',
  LoadSelectedOrgSuccess = '[Org Hierarchy] Load Selected Org Success',
  LoadSelectedOrgFailed = '[Org Hierarchy] Load Selected Org Failed',

  EditOrganization = '[Organization] Edit Organization',
  EditOrganizationFailed = '[Organization] Edit Organization Failed',
  EditOrganizationSucceeded = '[Organization] Edit Organization Succeeded',

  LoadOrgList = '[Organization] Load Org List',
  LoadOrgListSucceeded = '[Organization] Load Org List Succeeded',
  LoadOrgListFailed = '[Organization] Load Org List Failed',

  CreateNewOrg = '[Organization] Create New Org',
  CreateNewOrgSucceeded = '[Organization] Create New Org Succeeded',
  CreateNewOrgFailed = '[Organization] Create New Org Failed',

  LoadOrgHierarchy = '[Organization] Load Org Hierarchy',
  LoadOrgHierarchySuccess = '[Organization] Load Org Hierarchy Success',
  LoadOrgHierarchyFailed = '[Organization] Load Org Hierarchy Failed',
}

export class LoadOrg implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrg;

  constructor(public readonly payload: number) { };
}

export class LoadOrgSuccess implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgSuccess;

  constructor(public readonly payload: Organization) { };
}

export class LoadOrgFailed implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgFailed;

  constructor(public readonly payload: string) { };
}

export class LoadOrgSubscriptionStatus implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgSubscriptionStatus;

  constructor(public readonly payload: number) { };
}

export class LoadOrgSubscriptionStatusSuccess implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgSubscriptionStatusSuccess;

  constructor(public readonly payload: Organization) { };
}

export class LoadOrgSubscriptionStatusFailed implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgSubscriptionStatusFailed;

  constructor(public readonly payload: string) { };
}

export class LoadOrgChildren implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgChildren;

  constructor(public readonly payload: number) { };
}

export class LoadOrgChildrenSuccess implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgChildrenSuccess;

  constructor(public readonly payload: {id: number, children: Organization[]}) { };
}

export class LoadOrgChildrenFailed implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgChildrenFailed;

  constructor(public readonly payload: string) { };
}

export class SelectOrg implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.SelectOrg;

  constructor(public readonly payload: Organization) { };
}

export class SelectActiveNode implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.SelectActiveNode;

  constructor(public readonly payload: Organization) { };
}

export class LoadSelectedOrg implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadSelectedOrg;

  constructor(public readonly payload: number) { };
}

export class LoadSelectedOrgSuccess implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadSelectedOrgSuccess;

  constructor(public readonly payload: Organization) { };
}

export class LoadSelectedOrgFailed implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadSelectedOrgFailed;

  constructor(public readonly payload: string) { };
}

export class EditOrganization implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.EditOrganization;

  constructor(public readonly payload: {orgId: number, updates: any}) { }
}

export class EditOrganizationSucceeded implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.EditOrganizationSucceeded;
}

export class EditOrganizationFailed implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.EditOrganizationFailed;

  constructor(public readonly payload: string) { }
}

export class LoadOrgList implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgList;
}

export class LoadOrgListSucceeded implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgListSucceeded;

  constructor(public readonly payload: Organization[]) { };
}

export class LoadOrgListFailed implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgListFailed;

  constructor(public readonly payload: string) { }
}

export class CreateNewOrg implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.CreateNewOrg;

  constructor(public readonly payload: {
    name: string,
    parentId: number,
    adminEmail: string,
    tags: string[]
  }) { };
}

export class CreateNewOrgSucceeded implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.CreateNewOrgSucceeded;

  constructor(public readonly payload: Organization) { };
}

export class CreateNewOrgFailed implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.CreateNewOrgFailed;

  constructor(public readonly payload: string) { }
}

export class LoadOrgHierarchy implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgHierarchy;

  constructor(public readonly payload: number) { };
}

export class LoadOrgHierarchySuccess implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgHierarchySuccess;

  constructor(public readonly payload: any) { };
}

export class LoadOrgHierarchyFailed implements BaseAction<OrgHierarchyActions> {
  readonly type = OrgHierarchyActions.LoadOrgHierarchyFailed;

  constructor(public readonly payload: string) { };
}



export type OrgHierarchyAction = LoadOrg | LoadOrgSuccess | LoadOrgFailed
  | LoadOrgChildren | LoadOrgChildrenSuccess | LoadOrgChildrenFailed | SelectOrg
  | SelectActiveNode | LoadSelectedOrg | LoadSelectedOrgSuccess | LoadSelectedOrgFailed
  | LoadOrgSubscriptionStatus | LoadOrgSubscriptionStatusSuccess | LoadOrgSubscriptionStatusFailed
  | EditOrganization | EditOrganizationSucceeded | EditOrganizationFailed
  | LoadOrgList | LoadOrgListSucceeded | LoadOrgListFailed
  | CreateNewOrg | CreateNewOrgSucceeded | CreateNewOrgFailed
  | LoadOrgHierarchy | LoadOrgHierarchySuccess | LoadOrgHierarchyFailed;
